// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"448":"c44c5480c3cd3a7e","524":"81131169410101c7","606":"c70acb3cb91f2fe6"}[chunkId] + ".js";
};